<script>
    import {elements} from "../stores/elementData";
    import {
        me,
        pending,
        requested,
        claimDrop,
        dropHash, claimables,
        tokenMetadata as tokenMetadata_injected, cleanAddress,
        requestDropTokenMetadata as requestDropTokenMetadata_injected} from "../stores/contracts";
    import {
        tokenMetadata as tokenMetadata_infura,
        requestDropTokenMetadata as requestDropTokenMetadata_infura, useInfura} from "../stores/contracts-infura";

    let requestDropTokenMetadata, tokenMetadata;

    if($useInfura){
        requestDropTokenMetadata = requestDropTokenMetadata_infura;
        tokenMetadata = $tokenMetadata_infura;
    }else{
        requestDropTokenMetadata = requestDropTokenMetadata_injected;
        tokenMetadata = $tokenMetadata_injected;
    }


    // import {pending,requested,claimDrop,dropHash, claimables,tokenMetadata, cleanAddress, requestDropTokenMetadata} from "../stores/contracts";
    import TokenImage from "./TokenImage.svelte";

    import {navigateTo} from 'svelte-router-spa';

    export let drop;
    export let claimed = false;
    export let singlePage = false;
    export let openDrop = ()=>{}

    let name = "";
    let symbol = "";

    let tokenName = "";
    let tokenDescription = "";
    let tokenImage = "";

    let dropDetail = "";
    let dropDetailConcise = "";

    let claimable = false; //TODO: use this to format differently
    let hash = "";

    // [+ Atom# 8888]
    //     [86 Gold]
    // [86 Gold, Ion]
    //     [ion # +8]
    // [Next ion]


    let charge = (drop.ionCharge > 0) ? "+" + drop.ionCharge : drop.ionCharge.toString();
    if (drop.atomicNumber > 0 && drop.ionCharge === 0) {
        //next element
        if (elements.length >= drop.atomicNumber) {
            dropDetail = "Next " + elements[drop.atomicNumber - 1][2] + " atom.";
            dropDetailConcise = String(drop.atomicNumber).padStart(3,"0")+" "+elements[drop.atomicNumber - 1][2];
        } else {
            dropDetail = "Next ???";
            dropDetailConcise = "???";
        }
    } else if (drop.atomicNumber > 0) {
        //next element and ion
        if (elements.length >= drop.atomicNumber) {
            dropDetail = "Next " + elements[drop.atomicNumber - 1][2] + " ion with " + charge + " charge";
            dropDetailConcise = String(drop.atomicNumber).padStart(3,"0")+" "+elements[drop.atomicNumber - 1][2]+" "+charge;
        } else {
            dropDetail = "Next ???";
            dropDetailConcise = "???";
        }
    } else if (drop.ionCharge !== 0) {
        //ion charge
        dropDetail = "Next atom with " + charge + " charge";
        dropDetailConcise = "Ion "+charge;
    } else if (drop.isIon) {
        //is ion
        dropDetail = "Next ion.";
        dropDetailConcise = "Next Ion."
    } else {
        //atomicNumber
        dropDetail = "Any atom after #" + drop.tokenId;
        dropDetailConcise = "+ Atom #"+drop.tokenId;
    }

    requestDropTokenMetadata(drop.tokenAddress, drop.dropTokenId);

    let twitterLink  = "";
    function prepareTwitterLink(){
        let banned = "#\\/";
        let cleanName = "";
        for(let i = 0; i < tokenName.length; i++){
            if(!banned.includes(tokenName[i])) cleanName += tokenName[i];
        }

        return "https://twitter.com/intent/tweet?text=Check out "+cleanName+" on POW NFT DROPS!&url=https://drops.pownft.com/drop/"+drop.tokenAddress+"/"+drop.dropTokenId;
    }

    $:{


        if($useInfura){
            requestDropTokenMetadata = requestDropTokenMetadata_infura;
            tokenMetadata = $tokenMetadata_infura;
        }else{
            requestDropTokenMetadata = requestDropTokenMetadata_injected;
            tokenMetadata = $tokenMetadata_injected;
        }


        let tokenAddress = cleanAddress(drop.tokenAddress);
        let dropTokenId = parseInt(drop.dropTokenId);
        hash = dropHash(tokenAddress,dropTokenId);




        if (tokenMetadata[tokenAddress]) {
            name = tokenMetadata[tokenAddress].name;
            symbol = tokenMetadata[tokenAddress].symbol;
            let token = tokenMetadata[tokenAddress].tokens[dropTokenId];

            if(token && token.state === "loaded"){
                twitterLink = prepareTwitterLink();
            }

            if (token) {
                switch (token.state) {
                    default:
                    case "pending":
                        tokenName = "loading...";
                        tokenDescription = "loading...";
                        tokenImage = "";
                        break;
                    case "fail":
                        tokenName = "Unable to load";
                        tokenDescription = "Unable to load";
                        tokenImage = "fail";
                        break;
                    case "loaded":
                        tokenName = token.name;
                        tokenDescription = token.description;
                        tokenImage = token.image;
                        break;

                }
            } else {
                tokenName = "loading...";
                tokenDescription = "loading...";
                tokenImage = "";
            }
        }

        claimable = !$useInfura && ($claimables[tokenAddress] && $claimables[tokenAddress][dropTokenId] && $claimables[tokenAddress][dropTokenId].length > 0);
        // claimable = true;

    }

    //  tokens: {
    //      id: {
    //          state: pending, loaded, fail
    //          uri: "https://www."
    //          name: "token name"
    //          description: "token description"
    //          image: "https://www."
    //      }
    //  }

    function doClaim(){
        let tokenAddress = cleanAddress(drop.tokenAddress);
        let dropTokenId = parseInt(drop.dropTokenId);
        claimDrop(tokenAddress,dropTokenId,$claimables[tokenAddress][dropTokenId][0]);
    }

    function viewDrop(){
        if(claimed) return;
        // navigateTo("/Drop/"+drop.tokenAddress+"/"+drop.dropTokenId);
        openDrop(drop.tokenAddress,drop.dropTokenId);

    }



</script>

{#if !singlePage}
    <style>
        .listing{
            width: 320px;
            height:472px;
            /*background:red;*/
        }
        .listing:hover{
            background: rgba(255,255,255,0.5);
            cursor: pointer;
        }

        .boxIn{
            border-top:     solid black 2px;
            border-bottom:  solid white 2px;
            border-right:   solid white 2px;
            border-left:    solid black 2px;
        }
        .boxOut{
            border-top:     solid white 2px;
            border-bottom:  solid black 2px;
            border-right:   solid black 2px;
            border-left:    solid white 2px;
        }

        .tokenInfo{
            width:320px;
            height:400px;
            background: black;
        }
        .dropInfo{
            width:320px;
            height:65px;

        }
        .dropInfo span{
            /*padding*/
            /*background: red;*/
        }

        .dropDetails{

            display:flex;
            flex-direction: column;
            padding:15px;
            row-gap:5px;
        }


        .tokenDetails{
            color:white;
            display:flex;
            flex-direction: column;

            /*background: red;*/
            padding:15px;
            row-gap:10px;
            width:320px;

        }
        .tokenDetails span{
            color:white;
            font-family: sans-serif;
            text-overflow: ellipsis;
            font-size:16px;
            white-space: nowrap;
            overflow:hidden;
            /*overf*/
            /*width:100%;*/
            width:290px;

        }

        .claimable{
            background: #00ff99;
        }
        .claimable:hover{
            background: #87ffcc;
        }
        .pastDropLink {
            word-break: break-word;
        }

    </style>

    <div class="listing {claimable?'claimable':''}" on:click={viewDrop}>
        <!--        href="/Drop/{drop.tokenAddress}/{drop.dropTokenId}"-->
        <!--    Drop-->
        <div class="tokenInfo boxIn">
            <TokenImage src="{tokenImage}" displayType="listing"/>
            <div class="tokenDetails">

                    <span class="contractDetails">{name}
                        <!--{#if symbol !== ""}-->
                        <!--    ({symbol})-->
                        <!--{/if}-->

                    </span>
                <span class="tokenName">{tokenName}</span>
<!--                <span class="tokenDescription">{tokenDescription}</span>-->

            </div>
        </div>
        {#if !claimed}
            <div class="dropInfo boxOut">
                <div class="dropDetails">
                    <div>
                        TRIGGER [{dropDetailConcise}]
                    </div>
                    <div>
                        Probability  {Math.round(drop.probability*10000)/100}%
                    </div>
                </div>
            </div>
        {:else}
            <div class="dropInfo boxOut">
                <div class="dropDetails">
                    <div>
                        <a class="pastDropLink" target="_blank" href="https://opensea.io/assets/{drop.tokenAddress}/{drop.dropTokenId}">https://opensea.io/assets/{drop.tokenAddress}/{drop.dropTokenId}</a>
                    </div>
                </div>
            </div>
        {/if}
    </div>
{:else}

    <style>
        .boxIn{
            border-top:     solid black 2px;
            border-bottom:  solid white 2px;
            border-right:   solid white 2px;
            border-left:    solid black 2px;
        }
        .boxOut{
            border-top:     solid white 2px;
            border-bottom:  solid black 2px;
            border-right:   solid black 2px;
            border-left:    solid white 2px;
        }
        .listing-s{
            display: flex;
            flex-direction: row;
        }
        .tokenInfo-s{
            background: black;
            width:560px;
            height: 720px;
        }
        .tokenDetails-s{
            color:white;
            display:flex;
            flex-direction: column;

            /*background: red;*/
            padding:15px;
            row-gap:10px;
            /*width:320px;*/

        }
        .tokenDetails-s span{
            color:white;
            font-family: sans-serif;
            text-overflow: ellipsis;
            font-size:16px;

            /*overf*/
            /*width:100%;*/
            width:500px;
        }
        .contractDetails-s{
            white-space: nowrap;
            overflow:hidden;
        }
        .tokenName-s{
            white-space: nowrap;
            overflow:hidden;
        }

        .tokenDescription-s{
            height:75px;
            overflow:hidden;
            padding-right:40px;

            text-overflow: ellipsis;
        }
        .dropInfo-s{
            padding-left: 30px;
            width: 250px;
            /*background: red;*/
            display: flex;
            flex-direction: column;
            align-items: flex-start;

            font-size: 18px;
        }

        .claim{

        }
        h2{
            text-align: center;
            width:250px;
            font-size: 30px;
            padding-bottom: 40px;
        }
        .walletBox-s{
            width:250px;
            text-align: center;
            color:white;
            font-weight: bold;
            background: #242424;
            font-weight: bold;
            font-size: 20px;
        }
        .availableInfo-s{
            padding-bottom: 20px;
        }

        .transacting-s{
            display: inline-block;
            text-align: center;
            width:250px;
            text-decoration: none;
            color:black;
        }

        .linkBox-s{
            display: inline-block;
            text-align: center;
            width:250px;
            text-decoration: none;
            color:black;
            background: #dbdbdb;
            border-left:    solid white 2px;
            border-top:     solid white 2px;
            border-bottom:  solid black 2px;
            border-right:   solid black 2px;
        }
        .linkBox-s:visited{
            color:black;

        }
        .linkBox-s:hover{
            background: #f0f0f0;
            text-decoration: none;
        }
        .linkBox-s:active{
            background: #c8c8c8;
            border-left:    solid black 2px;
            border-top:     solid black 2px;
            border-bottom:  solid white 2px;
            border-right:   solid white 2px;
        }
        .linkLabel-s{
            margin-bottom:10px;
            margin-top:40px;
            width:250px;
            font-weight:bold;
            text-align:center;
        }


    </style>

    <div class="listing-s">
        <div class="tokenInfo-s  boxIn">
            <TokenImage src="{tokenImage}" displayType="focus"/>
            <div class="tokenDetails-s">

                <span class="contractDetails-s">Contract: {name}</span>
                <span class="tokenName-s">Title: {tokenName}</span>
                <span class="tokenDescription-s">Description: {tokenDescription}</span>

            </div>
        </div>
        <div class="dropInfo-s">
            <h2>
                {#if claimable}
                    Claimable DROP
                {:else}
                    Available DROP
                {/if}
            </h2>

            <div>Claimable by POW NFT Miner</div>

            {#if claimable}
                <div>Wallet address</div>
                <div class="walletBox-s boxIn">{me.substr(0,10)+"..............................."+me.slice(-8)}</div>
            {:else}
                <div class="availableInfo-s">Mining TRIGGER</div>
                <div class="availableInfo-s">NEXT</div>
                <div class="availableInfo-s">[{dropDetailConcise}]</div>
                <div class="availableInfo-s">Probability</div>
                <div class="availableInfo-s">{Math.round(drop.probability*10000)/100}%</div>
            {/if}

            <div>
                <div class="linkLabel-s">VIEW ON</div>
                <a class="linkBox-s" target="_blank" href="https://opensea.io/assets/{drop.tokenAddress}/{drop.dropTokenId}">https://opensea.io</a>
            </div>
            {#if twitterLink !== ""}
                <div class="marginTop20 marginBottom20">
                    <div class="linkLabel-s">SHARE ON TWITTER</div>
                    <a class="linkBox-s" target="_blank"
                       href="{encodeURI(twitterLink)}"
                    >https://twitter.com</a>
                </div>
            {/if}

            {#if claimable}
                <div class="marginTop20 marginBottom20">
                    <div class="linkLabel-s">&nbsp;</div>
                    {#if $pending.claimDrop[hash]}
                        <div class="transacting-s">Claiming...</div>
                    {:else if $requested.claimDrop[hash]}
                        <div class="transacting-s">Claiming...</div>
                    {:else}
                    <div class="linkBox-s"
                         on:click={doClaim}>
                    CLAIM DROP</div>
                    {/if}
                </div>

            {:else}
                <div>
                    <div class="linkLabel-s">MINE AN ATOM</div>
                    <a class="linkBox-s" target="_blank" href="https://www.pownft.com/">https://pownft.com</a>
                </div>
            {/if}
        </div>
    </div>
{/if}